import { render, staticRenderFns } from "./organization-control-detail.vue?vue&type=template&id=4f3f1ffb&scoped=true&"
import script from "./organization-control-detail.vue?vue&type=script&lang=js&"
export * from "./organization-control-detail.vue?vue&type=script&lang=js&"
import style0 from "./organization-control-detail.vue?vue&type=style&index=0&id=4f3f1ffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f1ffb",
  null
  
)

export default component.exports